export default __webpack_public_path__ + "static/media/agent.c5806a5c.png";